"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = DateInput;

var _range2 = _interopRequireDefault(require("lodash/range"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _layout = require("react-components/layout");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _media = require("react-components/media");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _typographyStyles = require("../../typography/typography-styles");

var _reactForms = require("@seegno/react-forms");

var _i18n = require("@slyk/i18n");

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _react = _interopRequireWildcard(require("react"));

var _reactDatepicker2 = _interopRequireDefault(require("react-datepicker/dist/react-datepicker.css"));

var _moment = _interopRequireDefault(require("moment"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["align", "dateFormat", "disabled", "id", "label", "locale", "maxDate", "minYear", "name"],
    _excluded2 = ["error", "meta", "onBlur", "onChange", "value"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var calendarIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\".963\"><path d=\"M10.7 4h10.6c4.3 0 7.7 3.4 7.7 7.7v8.7c0 4.3-3.4 7.7-7.7 7.7H10.7C6.4 28 3 24.6 3 20.3v-8.7C3 7.4 6.4 4 10.7 4z\"/><path d=\"M8.8 12.6h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1 .8-1.9 1.9-1.9zm0 6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1.1.8-1.9 1.9-1.9zm6.7-6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1 .9-1.9 1.9-1.9zm0 6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1.1.9-1.9 1.9-1.9zm6.8-6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c-.1-1 .8-1.9 1.9-1.9zm0 6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c-.1-1.1.8-1.9 1.9-1.9zM3.5 9.3h25\"/></g></svg>";
var caretIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" d=\"M2.667 4.667l2 2.1s0 0 0 0c.7.7 1.8.7 2.5 0l2.2-2.1\"/></svg>";

/**
 * Months.
 */
var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
/**
 * Date regex.
 */

var dateRegex = '^(0?[1-9]|[12][0-9]|3[01])[\\/](0?[1-9]|1[012])[\\/]\\d{4}$';
/**
 * `DatePickerWrapper` styled component.
 */

var DatePickerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "date-input__DatePickerWrapper",
  componentId: "sc-1llud7l-0"
})(["", " align-items:center;display:grid;grid-column-gap:8px;height:50px;position:relative;width:100%;", " ", " .react-datepicker{", ";border:1px solid ", ";border-radius:12px;color:", ";.react-datepicker__triangle{&::after{border-bottom-color:", ";}&::before{border-bottom-color:", ";}", "}}.react-datepicker-popper{left:-1px !important;transform:translate3d(0,56px,0) !important;z-index:", ";}.react-datepicker__header{background-color:", ";border-bottom:1px solid ", ";&--custom{border-top-left-radius:12px;border-top-right-radius:12px;}&:not(.react-datepicker__header--has-time-select){border-top-right-radius:12px;}}.react-datepicker__input-container input{background:none;border:none;color:", ";outline:none;transition:opacity ", ";width:100%;&:disabled{opacity:0.55;}", "}.react-datepicker__day-name{color:", ";}.react-datepicker__day{color:", ";&:hover{background-color:", ";}&--selected{background-color:", ";color:", ";}&--disabled{color:", ";}&--keyboard-selected{background-color:transparent;&:hover{background-color:", " !important;}}}"], _reactDatepicker2["default"], (0, _styledTools.switchProp)('align', {
  left: (0, _styledComponents.css)(["grid-template-columns:8px 24px 1fr;"]),
  right: (0, _styledComponents.css)(["grid-template-columns:1fr 24px 8px;"])
}), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 54px;\n  "]))), _typographyStyles.typography.styles.textSmall, (0, _styles.color)('gray200'), (0, _styles.color)('gray600'), (0, _styles.color)('gray200'), (0, _styles.color)('gray200'), (0, _styledTools.switchProp)('align', {
  // eslint-disable-next-line indent
  left: (0, _styledComponents.css)(["transform:translate3d(56px,0,0) !important;"]),
  // eslint-disable-next-line indent
  right: (0, _styledComponents.css)(["transform:translate3d(32px,0,0) !important;"]) // eslint-disable-next-line indent

}), (0, _styledTools.theme)('zIndex.dateInput.popper'), (0, _styles.color)('gray300'), (0, _styles.color)('gray200'), (0, _styles.color)('secondary'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.switchProp)('align', {
  // eslint-disable-next-line indent
  left: (0, _styledComponents.css)(["padding:12px 24px 12px 48px;"]),
  // eslint-disable-next-line indent
  right: (0, _styledComponents.css)(["padding:12px 0 12px 20px;"]) // eslint-disable-next-line indent

}), (0, _styles.color)('gray900'), (0, _styles.color)('gray900'), (0, _styles.color)('gray300'), (0, _styles.color)('gray400'), (0, _styles.color)('gray900'), (0, _styles.color)('gray400'), (0, _styles.color)('gray300'));
/**
 * `StyledLabel` styled component.
 */


var StyledLabel = (0, _styledComponents["default"])(_fieldsStyledComponents.Label).withConfig({
  displayName: "date-input__StyledLabel",
  componentId: "sc-1llud7l-1"
})(["top:10px;", " ", ""], (0, _styledTools.ifProp)('isHidden', (0, _styledComponents.css)(["clip-path:inset(50%);"])), (0, _styledTools.switchProp)('align', {
  left: (0, _styledComponents.css)(["left:48px;"]),
  right: (0, _styledComponents.css)(["left:20px;right:48px;"])
}));
/**
 * `StyledIcon` styled component.
 */

var StyledIcon = (0, _styledComponents["default"])(_media.Icon).withConfig({
  displayName: "date-input__StyledIcon",
  componentId: "sc-1llud7l-2"
})(["grid-row:1;transition:color ", ";", " ", ""], (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))), (0, _styledTools.switchProp)('align', {
  left: (0, _styledComponents.css)(["grid-column:2 / 3;"]),
  right: (0, _styledComponents.css)(["grid-column:-3 / -2;"])
}));
/**
 * `CalendarHeader` styled component.
 */

var CalendarHeader = _styledComponents["default"].div.withConfig({
  displayName: "date-input__CalendarHeader",
  componentId: "sc-1llud7l-3"
})(["align-items:center;display:grid;grid-template-columns:max-content 1fr max-content;padding:0 16px;"]);
/**
 * Button style.
 */


var buttonStyle = (0, _styledComponents.css)(["align-items:center;appearance:none;background:none;border:none;color:", ";cursor:pointer;display:flex;height:32px;justify-content:center;padding:0;transition:color ", ";width:32px;&:focus{outline:none;}&:disabled,&:focus,&:hover{color:", ";}"], (0, _styles.color)('gray400'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styles.color)('gray600'));
/**
 * `PreviousButton` styled component.
 */

var PreviousButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "date-input__PreviousButton",
  componentId: "sc-1llud7l-4"
})(["", " transform:rotate(90deg);"], buttonStyle);
/**
 * `CaretIcon` styled component.
 */


var CaretIcon = (0, _styledComponents["default"])(_media.Icon).attrs({
  'aria-hidden': true,
  icon: caretIcon,
  size: '16px'
}).withConfig({
  displayName: "date-input__CaretIcon",
  componentId: "sc-1llud7l-5"
})(["color:currentColor;"]);
/**
 * `DateSelectWrapper` styled component.
 */

var DateSelectWrapper = _styledComponents["default"].div.withConfig({
  displayName: "date-input__DateSelectWrapper",
  componentId: "sc-1llud7l-6"
})(["align-items:center;display:grid;grid-column-gap:16px;grid-template-columns:repeat(2,min-content);"]);
/**
 * `SelectWrapper` styled component.
 */


var SelectWrapper = _styledComponents["default"].div.withConfig({
  displayName: "date-input__SelectWrapper",
  componentId: "sc-1llud7l-7"
})(["align-items:center;display:flex;position:relative;"]);
/**
 * `Select` styled component.
 */


var Select = _styledComponents["default"].select.withConfig({
  displayName: "date-input__Select",
  componentId: "sc-1llud7l-8"
})(["", ";appearance:none;background:none;border:none;color:", ";outline:none;padding-right:12px;"], _typographyStyles.typography.styles.textSmall, (0, _styles.color)('gray900'));
/**
 * `SelectCaretIcon` styled component.
 */


var SelectCaretIcon = (0, _styledComponents["default"])(_media.Icon).attrs({
  'aria-hidden': true,
  icon: caretIcon,
  size: '12px'
}).withConfig({
  displayName: "date-input__SelectCaretIcon",
  componentId: "sc-1llud7l-9"
})(["pointer-events:none;position:absolute;right:0;"]);
/**
 * `NextButton` styled component.
 */

var NextButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "date-input__NextButton",
  componentId: "sc-1llud7l-10"
})(["", " transform:rotate(-90deg);"], buttonStyle);
/**
 * Export `DateInput` component.
 */


function DateInput(props) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'left' : _props$align,
      dateFormatValue = props.dateFormat,
      disabled = props.disabled,
      id = props.id,
      label = props.label,
      locale = props.locale,
      _props$maxDate = props.maxDate,
      maxDate = _props$maxDate === void 0 ? new Date() : _props$maxDate,
      _props$minYear = props.minYear,
      minYear = _props$minYear === void 0 ? 1970 : _props$minYear,
      name = props.name,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      meta = _useField.meta,
      _onBlur = _useField.onBlur,
      onChange = _useField.onChange,
      _useField$value = _useField.value,
      value = _useField$value === void 0 ? '' : _useField$value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var dateFormat = dateFormatValue !== null && dateFormatValue !== void 0 ? dateFormatValue : _moment["default"].localeData().longDateFormat('L');
  var active = meta.active;

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted;

  var hasError = !!error && alreadySubmitted;
  var fieldValue = !(0, _isEmpty2["default"])(value) ? (0, _moment["default"])(value, dateFormat).toDate() : null;

  var _useState = (0, _react.useState)(fieldValue),
      _useState2 = _slicedToArray(_useState, 2),
      dateValue = _useState2[0],
      setDateValue = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var hasValue = !!value;
  var years = (0, _react.useMemo)(function () {
    return (0, _range2["default"])(minYear, maxDate.getFullYear() + 1, 1);
  }, [maxDate, minYear]);
  var monthsOptions = (0, _react.useMemo)(function () {
    return months.map(function (month) {
      return {
        label: translate("months.".concat(month)),
        value: month
      };
    });
  }, [translate]);
  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    disabled: disabled,
    hasAlert: hasError
  }, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormControlWrapper, {
    disabled: disabled,
    hasError: hasError,
    hasFocus: active,
    hasValue: hasValue
  }, /*#__PURE__*/_react["default"].createElement(DatePickerWrapper, {
    align: align
  }, /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    align: align,
    "aria-hidden": true,
    color: (0, _styles.color)('gray500'),
    disabled: disabled,
    icon: calendarIcon,
    size: '24px'
  }), /*#__PURE__*/_react["default"].createElement(_layout.Box, {
    gridColumn: '1 / -1',
    gridRow: 1,
    position: 'relative'
  }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({}, rest, fieldProps, {
    adjustDateOnChange: false,
    dateFormat: 'dd/MM/yyyy',
    disabled: disabled,
    id: id !== null && id !== void 0 ? id : name,
    locale: locale,
    maxDate: maxDate,
    name: name,
    onBlur: function onBlur() {
      return _onBlur();
    },
    onCalendarClose: function onCalendarClose() {
      _onBlur();

      if ((0, _isEmpty2["default"])(value)) {
        setInputValue(undefined);
      }
    },
    onChangeRaw: function onChangeRaw(event) {
      var value = event.target.value;
      setInputValue(value);

      if (!(0, _isEmpty2["default"])(value) && !value.match(dateRegex)) {
        return;
      }

      if ((0, _isEmpty2["default"])(value)) {
        setDateValue(null);
        onChange(undefined);
      } else {
        var _value$split = value.split('/'),
            _value$split2 = _slicedToArray(_value$split, 3),
            day = _value$split2[0],
            month = _value$split2[1],
            year = _value$split2[2];

        var date = "".concat(year, "-").concat(month, "-").concat(day);

        if (!years.includes(Number(year))) {
          return;
        }

        setDateValue(new Date(date));
        onChange((0, _moment["default"])(date).format(dateFormat));
      }
    },
    onSelect: function onSelect(date) {
      setDateValue(date);
      onChange((0, _moment["default"])(date).format(dateFormat));
    },
    renderCustomHeader: function renderCustomHeader(_ref) {
      var changeMonth = _ref.changeMonth,
          changeYear = _ref.changeYear,
          date = _ref.date,
          decreaseMonth = _ref.decreaseMonth,
          increaseMonth = _ref.increaseMonth,
          nextMonthButtonDisabled = _ref.nextMonthButtonDisabled,
          prevMonthButtonDisabled = _ref.prevMonthButtonDisabled;
      return /*#__PURE__*/_react["default"].createElement(CalendarHeader, null, /*#__PURE__*/_react["default"].createElement(PreviousButton, {
        "aria-label": translate('calendar.actions.previous'),
        disabled: prevMonthButtonDisabled,
        onClick: decreaseMonth
      }, /*#__PURE__*/_react["default"].createElement(CaretIcon, null)), /*#__PURE__*/_react["default"].createElement(DateSelectWrapper, null, /*#__PURE__*/_react["default"].createElement(SelectWrapper, null, /*#__PURE__*/_react["default"].createElement(SelectCaretIcon, null), /*#__PURE__*/_react["default"].createElement(Select, {
        "aria-label": translate('calendar.labels.month'),
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return changeMonth(months.indexOf(value));
        },
        value: months[date.getMonth()]
      }, monthsOptions.map(function (_ref3, index) {
        var label = _ref3.label,
            value = _ref3.value;
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: value
        }, label);
      }))), /*#__PURE__*/_react["default"].createElement(SelectWrapper, null, /*#__PURE__*/_react["default"].createElement(SelectCaretIcon, null), /*#__PURE__*/_react["default"].createElement(Select, {
        "aria-label": translate('calendar.labels.year'),
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          changeYear(Number(value));
        },
        value: date.getFullYear()
      }, years.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option,
          value: option
        }, option);
      })))), /*#__PURE__*/_react["default"].createElement(NextButton, {
        "aria-label": translate('calendar.actions.next'),
        disabled: nextMonthButtonDisabled,
        onClick: increaseMonth
      }, /*#__PURE__*/_react["default"].createElement(CaretIcon, null)));
    },
    selected: dateValue
  })), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    align: align,
    disabled: disabled,
    htmlFor: id !== null && id !== void 0 ? id : name,
    isHidden: hasValue || !!inputValue
  }, label)))), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: !!error,
    name: name
  }));
}